import React from 'react'
import styles from 'modules/Services/Network/subcomponents/HighRiskLabel/high-risk.module.scss'
import { Grid, Typography } from 'gu-ui-kit'
import PropTypes from 'prop-types'
import clsx from 'clsx'

const HighRiskLabel = ({ size = 'm' }) => (
  <Typography
    variant={size === 's' || size === 'xs' ? 'Body-5' : 'Body-10'}
    color={'Label-Onsurface'}
    component={
      <Grid
        alignItems={'center'}
        fluid={false}
      />
    }
    noWrap
    className={clsx(styles['high-risk'], {
      [styles[`high-risk_size_${size}`]]: size,
    })}
  >
    High Risk
  </Typography>
)

export default HighRiskLabel

HighRiskLabel.propTypes = {
  size: PropTypes.oneOf(['xs', 's', 'm']),
}
